import React from "react";
import { Line } from "./Styled";
import { Input } from "antd";
import { Field, FieldArray } from "formik";
import { Select } from "formik-antd";
import operators from "../../../../model/workflowEditor/Operators";
import { Condition, Flow } from "../../../../model/workflowEditor/flow/types";
import { LinkModel } from "../../../../model/workflowEditor/link/LinkModel";
import BuilderContext from "../../../context/BuilderContext";
import BaseWidgetForm from "../baseWidgetForm/BaseWidgetForm";

type LinkFormProps = {
  link: LinkModel;
  flow: Flow;
};

interface LinkFormValues {
  condition?: Condition;
}
const LinkForm: React.FunctionComponent<LinkFormProps> = ({
  link,
  flow
}) => {
  const initialValues: LinkFormValues = { condition: link.data.condition };
  const { builder } = React.useContext(BuilderContext);

  const onSubmit = (values: any) => {
        link.addCondition(values.condition!);
        builder?.repaint();
  }

  const renderForm = (formik: any) => {
    return  <FieldArray
    name="messages"
    render={arrayHelpers => (
      <Line>
            {renderSlotField()}
            {renderOperatorField()}
            <Field
              name="condition.value"
              // @ts-ignore
              render={({ field, meta }) => (
                <div>
                  <Input type="text" {...field} placeholder="Value" />
                  {meta.touched && meta.error && meta.error}
                </div>
              )}
            />
      </Line>
    )}
  />
  }


  const renderOperatorField = () => {
    return (
        <Select
          name="condition.operator"
          showSearch
          style={{ minWidth: '130px' }}
          placeholder="Operator"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {operators.map(({ label, value }) => { return <Select.Option value={value}>{label}</Select.Option> })}
        </Select>
    );
  };

  const renderSlotField = () => {
    return <Select
          name="condition.slot"
          showSearch
          style={{ minWidth: '130px' }}
          placeholder="Slot"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {flow.slots?.map((item) => { return <Select.Option value={item.name}>{item.name}</Select.Option> })}
        </Select>
  }

  return ( 
     <BaseWidgetForm
     title='CONDITION'
     initialValues={initialValues}
     onSubmit={onSubmit}
     renderForm={renderForm}
   />
  );
};

export default LinkForm;
